<template lang="pug">
  v-dialog(v-model='dialog', persistent max-width='30%')
    v-card(color='grey_1')
      v-app-bar(dark color='primary')
        span.headline {{ formTitle }}
      v-card-text
        v-row(dense)
          v-col(cols='12')
            v-card(color='white')
              v-card-text
                v-row(dense)
                  v-col(cols='12', sm='12', md='12')
                    v-text-field(dense, outlined, id="codMarca", type='number' v-model='form.codMarca', label='Código')
                v-row(dense)
                  v-col(cols='12', sm='12', md='12')
                    v-text-field(dense, outlined, id="nombreMarca", v-model='form.nombre', label='Nombre', v-uppercase)
      v-card-actions
        v-spacer
        v-btn(color='error', small dark @click='close')
          v-icon mdi-close
          | Cancelar
        v-btn(color='success', small dark @click='save')
          v-icon mdi-content-save
          | Guardar
</template>
<script>
import Api from '@/services/methods'

export default {
  props: ['dialog', 'editedIndex', 'FormPadre', 'read'],
  data: () => ({
    form: {
      nombre: '',
      codMarca: ''
    },
    defaultItem: {
      nombre: '',
      codMarca: ''
    }
  }),
  computed: {
    formTitle () {
      return this.editedIndex === -1
        ? 'Nueva Marca'
        : this.read
          ? 'Informacion de la Marca'
          : 'Modificar Marca'
    }
  },
  watch: {
    FormPadre (val) {
      // formulario que llega del padre, para editar y ver
      if (Object.keys(val).length !== 0) {
        this.form = val
      }
    }
  },
  methods: {
    close () {
      setTimeout(() => {
        this.form = Object.assign({}, this.defaultForm)
      }, 300)
      this.$emit('close')
    },
    validarCampos () {
      if (this.form.nombre === '' || this.form.codMarca === '') {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text: 'Por favor llene los campos para continuar'
        })
        return true
      } else if (this.form.nombre.length > 60) {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text: 'Ha excedido el limite de caracteres'
        })
        return true
      }
      return false
    },
    save () {
      if (!this.validarCampos()) {
        this.$swal({
          title: 'Cargando...',
          html: 'Esperando respuesta del servidor',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            this.$swal.showLoading()
          }
        })
        if (this.editedIndex > -1) {
          Api.put('marca', this.form)
            .then(response => {
              this.$emit('edited')
              this.$swal({
                icon: 'success',
                title: 'Modificacion exitosa',
                text: 'Todos los cambios han sido efectuados'
              })
              this.close()
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al modificar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message);
              }
            })
        } else {
          Api.post('marca', this.form)
            .then(response => {
              this.$emit('save')
              this.$swal({
                icon: 'success',
                title: 'Inclusion exitosa',
                text: 'Todos los datos han sido guardados'
              })
              this.close()
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al guardar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message);
              }
            })
        }
      }
    }
  }
}
</script>
